export const BREADCRUMBS_GET_REQUEST = 'BREADCRUMBS_GET_REQUEST';
export const BREADCRUMBS_GET_SUCCESS = 'BREADCRUMBS_GET_SUCCESS';
export const BREADCRUMBS_GET_FAILURE = 'BREADCRUMBS_GET_FAILURE';
